
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

interface AuthenticateShopifyPrivateAppRequest {
    shopUrl: string;
    apiKey: string;
    accessToken: string;
    companyId?: string;
}

const authenticateShopifyPrivateApp = async (shopUrl: string, apiKey: string, accessToken: string, companyId?: string): Promise<void> => {
    const authenticateShopifyPrivateApp = httpsCallable<AuthenticateShopifyPrivateAppRequest, any>(functions, 'shopify_auth_private_app');
    await authenticateShopifyPrivateApp({ shopUrl, apiKey, accessToken, companyId });
};

export { authenticateShopifyPrivateApp };
